namespace $ { $mol_style_attach( "mol/plot/pane/pane.view.css",
 "[mol_plot_pane] {\n\tcolor: var(--mol_theme_control);\n\tflex: 1 1 auto;\n\talign-self: stretch;\n\tstroke-width: 2px;\n\tuser-select: none;\n}\n"
) }